import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import styles2 from 'assets/scss/views/Auth2.scss'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { Button, Form, PinCodeField } from '../components'
import { pingUser } from '../services/networkService'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import AuthContent from './AuthContent'
import { WaitRender } from '../components/WaitRender/WaitRender'
import { resetPasswordRequest } from '../actions/AuthAction'

const mapStateToProps = state => {
  const { AuthReducer, FlowReducer } = state
  const { user = {}, error } = AuthReducer
  const { property } = FlowReducer
  const { mobileNumber, id } = user

  return {
    mobileNumber,
    id,
    property,
    error,
  }
}

const mapDispatchToProps = dispatch => ({
  resetPasswordRequest: mobileNumber => dispatch(resetPasswordRequest(mobileNumber)),
})

class ResetPasswordRequestedView extends React.PureComponent {
  static propTypes = {
    mobileNumber: PropTypes.string,
    property: PropTypes.any,
    history: PropTypes.any,
    resetPasswordRequest: PropTypes.func,
  }
  state = {
    pincode: '',
    // countdownCount: 1,
  }

  resendSms = () => {
    // if (this.state.countdownCount >= 3) {
    //   return
    // }

    // this.setState({
    //   countdownCount: this.state.countdownCount + 1,
    // })

    // TODO: Captcha should be passed
    // this.props.resetPasswordRequest(this.props.mobileNumber)

    routeService.goToForgotPasswordPage()
  }

  onValueChange = event => {
    const { id, value } = event.target
    this.setState(
      {
        [id]: value,
      },
      () => {
        if (value.length === 6) {
          this.confirmPhoneNumber(event)
        }
      },
    )
  }

  confirmPhoneNumber = async event => {
    if (event.preventDefault) {
      event.preventDefault()
    }
    try {
      await pingUser({ token: this.state.pincode })
      routeService.goToResetPasswordPage(this.state.pincode)
    } catch (error) {
      this.setState({ error })
    }
  }

  render() {
    const { pincode, error } = this.state

    return (
      <AuthContent
        title={translationService.passwordResetRequestSentTitle()}
        subtitle={translationService.passwordResetRequestSentIntro()}
        hasToken={false}>
        <Form onSubmit={this.confirmPhoneNumber}>
          <PinCodeField
            id="pincode"
            max={6}
            fields={6}
            error={error && translationService.verificationWrongResetCode()}
            value={pincode}
            onChange={this.onValueChange}
            label={translationService.verificationPincodeLabel()}
          />
          <div>
            <Button primary onClick={this.confirmPhoneNumber}>
              {translationService.buttonNext()}
            </Button>
          </div>
        </Form>

        <div className={styles2.Spacer} />

        <WaitRender
          // key={`countdown_count-${this.state.countdownCount}`}
          timeout={60000}
          withCountdown
          renderCountdown={secondsLeft => (
            <div>
              <Button disabled>{`${translationService.passwordResetPasswordRequestAgain()} (${secondsLeft})`}</Button>
            </div>
          )}>
          <div>
            <Button onClick={this.resendSms}>{translationService.passwordResetPasswordRequestAgain()}</Button>
          </div>
        </WaitRender>

        <div className={styles2.Spacer} />

        <div>
          <Link to={routeService.getPrefixPath() + '/login'}>{translationService.passwordResetSuccessToLogin()}</Link>
        </div>
      </AuthContent>
    )
  }
}

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ResetPasswordRequestedView)



// WEBPACK FOOTER //
// ./src/views/ResetPasswordRequestedView.js